import Http from "../util/Http";
import { uploadImageFile } from "../util/ImageService";

class ExpertProductApi {
    
    // Get single expert product
    static async getExpertProduct(expertProductId, isFull = false, isMine = false) {
        const queryParams = new URLSearchParams({
            isFull: isFull.toString(),
            isMine: isMine.toString()
        }).toString();
        
        const res = await Http.get(`/expert-products/${expertProductId}?${queryParams}`);
        return res || null;
    }

    // Get list of expert products with pagination and filtering
    static async getExpertProducts({category = '', page = 1, cnt = 20, searchKeyword = '', status = '', isMine = false, expert_product_owner_id = '', isFavoriteOnly = false}) {
        const queryParams = new URLSearchParams({
            category,
            page: page.toString(),
            cnt: cnt.toString(),
            searchKeyword,
            status,
            isMine: isMine.toString(),
            expert_product_owner_id,
            isFavoriteOnly: isFavoriteOnly.toString()
        }).toString();
        
        const res = await Http.get(`/expert-products?${queryParams}`);
        return res || null;
    }

    // Get total count of expert products
    static async getExpertProductsTotalCount({category = '', searchKeyword = '', status = '', isMine = false, isFavoriteOnly = false}) {
        const queryParams = new URLSearchParams({
            category,
            searchKeyword,
            total: 'true',
            status,
            isMine: isMine.toString(),
            isFavoriteOnly: isFavoriteOnly.toString()
        }).toString();
        
        const res = await Http.get(`/expert-products?${queryParams}`);
        return res || 0;
    }

    // Create new expert product
    static async createExpertProduct(productData) {
        const res = await Http.post('/expert-products', productData);
        return res || null;
    }

    // Update existing expert product
    static async updateExpertProduct(expertProductId, productData) {
        const res = await Http.put(`/expert-products/${expertProductId}`, productData);
        return res || null;
    }

    static async updateExpertProductAfterPay(paymentResult) {
        const res = await Http.post('/expert-products/after-pay', paymentResult);
        return res || null;
    }

    // Delete single expert product
    static async deleteExpertProduct(expertProductId) {
        const res = await Http.delete(`/expert-products/${expertProductId}`);
        return res || null;
    }

    // Delete multiple expert products
    static async deleteMultipleExpertProducts(productIds) {
        const res = await Http.post('/expert-products/delete-multiple', { product_ids: productIds });
        return res || null;
    }

    // Update visit count
    static async updateVisitCount(expertProductId) {
        const res = await Http.post(`/expert-products/${expertProductId}/visit`);
        return res || null;
    }

    // Update like count
    static async updateLikeCount(expertProductId) {
        const res = await Http.post(`/expert-products/${expertProductId}/like`);
        return res || null;
    }

    // Toggle like (add/remove)
    static async toggleLike(expertProductId) {
        const res = await Http.post(`/expert-products/${expertProductId}/like/toggle`);
        return res || null;
    }

    // Get services for a product
    static async getServices(expertProductId) {
        const res = await Http.get(`/expert-products/${expertProductId}/services`);
        return res || null;
    }

    // Get FAQs for a product
    static async getFaqs(expertProductId) {
        const res = await Http.get(`/expert-products/${expertProductId}/faqs`);
        return res || null;
    }

    // Get terms for a product
    static async getTerm(expertProductId) {
        const res = await Http.get(`/expert-products/${expertProductId}/term`);
        return res || null;
    }

    // Get document for a product
    static async getDocument(expertProductId) {
        const res = await Http.get(`/expert-products/${expertProductId}/document`);
        return res || null;
    }


    // Upload expert product banner image
    static async uploadBannerImage(file) {
        return uploadImageFile(file, 'banner', 'image');
    }


    static async getTotalBoardSecExpertProducts(types=[]) {
        const queryParams = new URLSearchParams({
            types: types.join(',')
        }).toString();
        
        const res = await Http.get(`/expert-products/totalBoardSec?${queryParams}`);
        return res || null;
    }
}

export default ExpertProductApi;
